(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7429],{

/***/ 63904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41799);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_in_viewport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28447);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62062);
/* harmony import */ var ab_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(276);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(145);
/* harmony import */ var ab_paragraph_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2569);
/* harmony import */ var _carrousel_home_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6903);
/* harmony import */ var _carrousel_home_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_carrousel_home_scss__WEBPACK_IMPORTED_MODULE_8__);










var CarrouselHome = function(param) {
    var _title = param.title, title = _title === void 0 ? "Una experiencia gastron\xf3mica" : _title, _text = param.text, text = _text === void 0 ? [] : _text, content = param.content, contentFull = param.contentFull, cards = param.cards, _className = param.className, className = _className === void 0 ? "" : _className, _classname = param.classname, classname = _classname === void 0 ? "" : _classname, animated = param.animated, singleColumn = param.singleColumn, singlecolumn = param.singlecolumn, _element = param.element, element = _element === void 0 ? "h2" : _element, textClass = param.textClass, textclass = param.textclass, h1 = param.h1, navlink = param.navlink, i18n = param.i18n;
    // console.log("links", links);
    // console.log("CarrouselHome", contentFull);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewMore = ref[0], setViewMore = ref[1];
    var myRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var slider = document.querySelector("#carrousel-home");
        if (slider) {
            slider.addEventListener("scroll", function() {
                var video0 = document.querySelector("#video_0");
                var video1 = document.querySelector("#video_1");
                var video2 = document.querySelector("#video_2");
                var video3 = document.querySelector("#video_3");
                var hideVideo = function(video) {
                    if (video) {
                        video.style.opacity = 0;
                    }
                };
                if ((slider === null || slider === void 0 ? void 0 : slider.scrollLeft) < window.innerWidth / 2 && video0) {
                    video0.style.opacity = 1;
                    video0.style.display = "flex";
                    hideVideo(video1);
                    hideVideo(video2);
                    hideVideo(video3);
                }
                if (slider.scrollLeft > window.innerWidth / 2 && video1) {
                    video1.style.opacity = 1;
                    video1.style.display = "flex";
                    hideVideo(video0);
                    hideVideo(video2);
                    hideVideo(video3);
                }
                if (slider.scrollLeft > window.innerWidth + window.innerWidth / 2 && video2) {
                    video2.style.opacity = 1;
                    video2.style.display = "flex";
                    hideVideo(video0);
                    hideVideo(video1);
                    hideVideo(video3);
                }
                if (slider.scrollLeft > 2 * window.innerWidth + window.innerWidth / 2 && video3) {
                    video3.style.opacity = 1;
                    video3.style.display = "flex";
                    hideVideo(video0);
                    hideVideo(video1);
                    hideVideo(video2);
                }
            });
        }
        return function() {};
    }, [
        content
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var slider = document.querySelector("#carrousel-home");
        // const circle = document.querySelector('#circle');
        var isDown = false;
        var startX;
        var scrollLeft;
        if (slider) {
            slider.addEventListener("mousedown", function(e) {
                isDown = true;
                slider.classList.add("active");
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener("mouseleave", function() {
                isDown = false;
                slider.classList.remove("active");
            });
            slider.addEventListener("mouseup", function() {
                isDown = false;
                slider.classList.remove("active");
                slider.classList.remove("prevent-clic");
            });
            slider.addEventListener("mousemove", function(e) {
                if (!isDown) return;
                e.preventDefault();
                slider.classList.add("prevent-clic");
                var x = e.pageX - slider.offsetLeft;
                var walk = x - startX; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
            });
            slider.addEventListener("mouseover", function(e) {
            // if (circle) {
            //   circle.style.opacity = 1;
            //   circle.style.height = '70px';
            //   circle.style.width = '70px';
            // }
            });
        }
        document.addEventListener("mousemove", function(e) {
        // if (circle) {
        //   circle.style.left = e.pageX - 35 + 'px';
        //   circle.style.top = e.pageY - 40 + 'px';
        // }
        });
    }, []);
    var myRef2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref1 = (0,react_in_viewport__WEBPACK_IMPORTED_MODULE_2__/* .useInViewport */ .NM)(myRef2, {
        threshold: 0.5
    }, {
        onEnterViewport: function() {
        // console.log("entered viewport");
        }
    }, {
        disconnectOnLeave: false
    }), inViewport = ref1.inViewport, enterCount = ref1.enterCount, leaveCount = ref1.leaveCount;
    var handleScroll = function() {
        var element = document.getElementById("menu-#".concat(navlink));
        var menu = document.getElementById("history-menu");
        if (element) {
            if (inViewport) {
                var ref;
                if (!(element === null || element === void 0 ? void 0 : (ref = element.classList) === null || ref === void 0 ? void 0 : ref.contains("selected"))) {
                    var children = menu === null || menu === void 0 ? void 0 : menu.querySelectorAll("li");
                    children.forEach(function(e) {
                        if (e.id !== element.id) {
                            e === null || e === void 0 ? void 0 : e.classList.remove("selected");
                            e === null || e === void 0 ? void 0 : e.classList.add("not-selected");
                        }
                    });
                    element === null || element === void 0 ? void 0 : element.classList.add("selected");
                    element === null || element === void 0 ? void 0 : element.classList.remove("not-selected");
                    menu.scrollLeft = (element === null || element === void 0 ? void 0 : element.offsetLeft) - 10;
                }
            } else {
                var ref1;
                if (!(element === null || element === void 0 ? void 0 : (ref1 = element.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("not-selected"))) {
                    element === null || element === void 0 ? void 0 : element.classList.remove("selected");
                    element === null || element === void 0 ? void 0 : element.classList.add("not-selected");
                }
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        inViewport
    ]);
    var renderCards = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "row",
            id: "carrousel-home",
            ref: myRef,
            children: cards === null || cards === void 0 ? void 0 : cards.map(function(card, index) {
                var ref, ref1, ref2, ref3;
                // console.log("CarrouselHome cards", cards);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: card === null || card === void 0 ? void 0 : (ref = card.link) === null || ref === void 0 ? void 0 : ref.url,
                    className: "card",
                    children: [
                        (card === null || card === void 0 ? void 0 : (ref1 = card.imagen) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: (card === null || card === void 0 ? void 0 : (ref2 = card.imagen) === null || ref2 === void 0 ? void 0 : ref2.mediaItemUrl) || "/images/404.png",
                            layout: "fill",
                            alt: card === null || card === void 0 ? void 0 : card.title
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            className: "image web",
                            src: card === null || card === void 0 ? void 0 : card.video,
                            id: "video_".concat(index),
                            ref: videoRef,
                            loop: true,
                            playsInline: true,
                            muted: true,
                            autoPlay: true,
                            preload: "auto",
                            poster: card === null || card === void 0 ? void 0 : (ref3 = card.imagen) === null || ref3 === void 0 ? void 0 : ref3.mediaItemUrl,
                            style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, !(card === null || card === void 0 ? void 0 : card.video) ? {
                                opacity: 0.9
                            } : {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: "card-title",
                            children: card === null || card === void 0 ? void 0 : card.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: "card-description",
                            children: card === null || card === void 0 ? void 0 : card.descripcion
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "arrow",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                src: "/images/arrow.png",
                                alt: "Ver ".concat(card === null || card === void 0 ? void 0 : card.title),
                                height: 12,
                                width: 15
                            })
                        })
                    ]
                }, card === null || card === void 0 ? void 0 : card.title);
            })
        });
    };
    if (!singlecolumn && !singleColumn) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "carrousel-home horizontal ".concat(className || classname || ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        h1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            element: "h1",
                            children: h1
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            element: element,
                            animated: animated,
                            className: textClass || textclass,
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_paragraph_text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            text: text,
                            content: content,
                            singleColumn: true
                        })
                    ]
                }),
                (cards === null || cards === void 0 ? void 0 : cards.length) ? renderCards() : null
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            navlink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: "reference",
                style: {
                    top: -90
                },
                id: navlink
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "carrousel-home ".concat(className || classname || ""),
                ref: myRef2,
                children: [
                    h1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        element: "h1",
                        children: h1
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        element: element,
                        animated: animated,
                        className: textClass || textclass,
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_paragraph_text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        text: text,
                        content: viewMore ? contentFull : content,
                        singleColumn: singleColumn || singlecolumn
                    }),
                    (cards === null || cards === void 0 ? void 0 : cards.length) ? renderCards() : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_paragraph_text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        text: text,
                        className: "duplicate",
                        singleColumn: singleColumn || singlecolumn
                    }),
                    contentFull ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        prefetch: false,
                        text: viewMore ? t("cerrar") : t("leer-mas"),
                        style: {
                            alignSelf: "center",
                            marginTop: 25
                        },
                        onClick: function() {
                            setViewMore(!viewMore);
                        }
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CarrouselHome);


/***/ }),

/***/ 2569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41257);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__);




var ParagraphText = function(param) {
    var _text = param.text, text = _text === void 0 ? [] : _text, singleColumn = param.singleColumn, className = param.className, content = param.content, noPlus = param.noPlus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewMore = ref9[0], setViewMore = ref9[1];
    // console.log("ParagraphText", content, text);
    var parsedHtml = content ? (ref8 = (ref7 = (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = content === null || content === void 0 ? void 0 : content.replace(/<div>/g, "<p>")) === null || ref === void 0 ? void 0 : ref.replace(/<\/div>/g, "</p>")) === null || ref1 === void 0 ? void 0 : ref1.replace(/<div class/g, "<p class")) === null || ref2 === void 0 ? void 0 : ref2.replace(/<ul>/g, "<p><ul>")) === null || ref3 === void 0 ? void 0 : ref3.replace(/<\/ul>/g, "</ul></p>")) === null || ref4 === void 0 ? void 0 : ref4.replace(/<p>/g, "")) === null || ref5 === void 0 ? void 0 : ref5.replace(/\n/g, "")) === null || ref6 === void 0 ? void 0 : ref6.replace(/\r/g, "")) === null || ref7 === void 0 ? void 0 : ref7.split("</p>")) === null || ref8 === void 0 ? void 0 : ref8.filter(function(e) {
        return e;
    }) : [];
    // console.log("ParagraphText - content", content);
    // console.log("ParagraphText - parsedHtml", parsedHtml);
    // console.log("ParagraphText - text", text);
    if (text.length == 0 && parsedHtml.length == 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-paragraph-text ".concat(className || "", " ").concat(viewMore ? "full" : ""),
        style: {
            // height: maxHeight,
            columnCount: singleColumn ? undefined : 2,
            display: singleColumn ? "flex" : "block",
            columnGap: singleColumn ? undefined : 36,
            columnFill: singleColumn ? undefined : "balance"
        },
        children: [
            parsedHtml === null || parsedHtml === void 0 ? void 0 : parsedHtml.map(function(itm, index) {
                if (!itm) {
                    return null;
                }
                if (noPlus) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "no-plus show",
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (index == 0 || parsedHtml.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? parsedHtml.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || parsedHtml.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (parsedHtml.length > 1 && index == parsedHtml.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        className: viewMore && (itm === null || itm === void 0 ? void 0 : itm.includes("<ul>")) ? "less" : "",
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            }),
            text === null || text === void 0 ? void 0 : text.filter(function(e) {
                return e;
            }).map(function(itm, index) {
                if (index == 0 || text.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? text.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || text.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (text.length > 1 && index == text.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParagraphText);


/***/ }),

/***/ 6903:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41257:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);